import React, { Dispatch } from 'react';
import { AppActionsType, AppState } from '../../reducers/app-reducer/types';

export interface GlobalContextProps {
  state: AppState,
  dispatch?: Dispatch<AppActionsType>
}

let langtag: string | null | undefined = localStorage.getItem('langtag') || 'en'
localStorage.setItem('langtag', 'en')

const requireAuthenticator = localStorage.getItem('authenticated') == 'true'

export const initialState: AppState = {
  expandedY: false,
  requireAuthenticator,
  initialState: 'signUp',
  langtag
}

export const GlobalContext = React.createContext<GlobalContextProps>({ state: initialState })